import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrypto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"crypto"} maskId="square-filled-radius-0-stroke-1-IconCrypto"><path d="M8 14.3093V9.69064L12 7.3813L16 9.69064V14.3093L12 16.6186L8 14.3093Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 6.22661L7 9.11328V14.8867L12 17.7733L17 14.8867V9.11328L12 6.22661Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCrypto;
